export class ConstantsLocalApi {
    // empty string means it is a relative url
    public static readonly LocalUrl: string = "";

    public static readonly PartApiPath: string = "/api";
}
